import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useAuth0 } from "@auth0/auth0-react";
import { useQueryString } from "@/hooks";

interface CallbackParams {
  partnerSlug: string;
}

function useAuthCallback(partnerSlug: string) {
  const { isAuthenticated, isLoading } = useAuth0();
  const history = useHistory();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      history.replace(`/portal/${partnerSlug}`);
    } else if (!isLoading && !isAuthenticated) {
      history.replace(`/portal/auth/login?partnerSlug=${partnerSlug}`);
    }
  }, [isLoading, isAuthenticated, partnerSlug, history]);
}

export function PortalCallbackPage() {
  const { partnerSlug } = useQueryString<CallbackParams>() || {
    partnerSlug: localStorage.getItem("partnerSlug"),
  };
  useAuthCallback(partnerSlug);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <Spinner animation="border" />
    </div>
  );
}
